import { InitializeSyncMapItemProps } from "./initializeSyncMapItem.type";

export const initializeSyncMapItem = async ({ client, conversationSid }: InitializeSyncMapItemProps) => {
    const map = await client.map("chat-conversations");
    const mapItem = await map.get(conversationSid);

    return {
        map,
        mapItem
    };
};
